export class Stack<T> {

  _store: T[] = [];

  push(val: T) {
    this._store.push(val);
  }

  pop(): T | undefined {
    return this._store.pop();
  }

  peek(): T | undefined {
    if (this._store.length <= 0) {
      return this.pop();
    } else {
      return this._store[this._store.length - 1];
    }
  }

  clear() {
    this._store = [];
  }

  size() {
    return this._store.length;
  }
}
